// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__2bfj1","Logo":"Toolbar_Logo__33EPx","DesktopOnly":"Toolbar_DesktopOnly__3ulkV"};